export const OPEN_DILAOG = 'OPEN_DIALOG'
export const CLOSE_DILAOG = 'CLOSE_DIALOG'
export const DIALOG_LOADING = 'DIALOG_LOADING'

export const FETCH_DIALOG_REQUEST = 'FETCH_DIALOG_REQUEST'
export const FETCH_DIALOG_SUCCESS = 'FETCH_DIALOG_SUCCESS'
export const FETCH_DIALOG_ERROR = 'FETCH_DIALOG_ERROR'

export const openDialog = (id) => {
    return {type: OPEN_DILAOG, payload: {id}}
}

export const closeDialog = (id) => {
    return {type: CLOSE_DILAOG, payload: {id}}
}

export const dialogLoading = (id, loading) => {
    return {type: DIALOG_LOADING, payload: {id, loading}}
}

export const fetchDialogRequest = (path, method, payload, message) => {
    return {
        type: 'CALL_API',
        types: [FETCH_DIALOG_REQUEST, FETCH_DIALOG_SUCCESS, FETCH_DIALOG_ERROR],
        path: path,
        method: method,
        payload: payload,
        message: message,
    };
}


// WEBPACK FOOTER //
// ./src/actions/dialog.js